export default __webpack_public_path__ + "static/media/croak-346.2c13dacc.mp3";